import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogResult } from 'src/app/shared/dialogs/models';

@Component({
  templateUrl: './delete-comment-dialog.component.html',
  styleUrls: ['./delete-comment-dialog.component.scss'],
  standalone: false,
})
export class DeleteCommentDialogComponent {
  constructor(private dialogRef: MatDialogRef<DeleteCommentDialogComponent, DialogResult>) {}

  public close(): void {
    this.dialogRef.close({ done: false });
  }

  public done(): void {
    this.dialogRef.close({ done: true });
  }
}
